import React, { useState, useEffect } from 'react';
import { View, Text, TextInput, TouchableOpacity } from 'react-native';
import { Checkbox } from 'react-native-paper';
import { LinearGradient } from "expo-linear-gradient";

import HeaderDefault from '../../components/HeaderDefault';

import styles from "./styles";

const SellExchange = ({ navigation, route }) => {
    const [checked, setChecked] = useState(false);
    const [qtd, setQtd] = useState(0);
    const [token, setToken] = useState(null);
    const [valueCoin, setValueCoin] = useState(0);

    useEffect(() => {
        setToken(route.params.token);
        setQtd(route.params.qtd);
        //   console.log(token)
    }, []);

    return (
        <>
            <HeaderDefault title={"EXCHANGE"} />

            <View style={styles.content}>
                <Text style={styles.titlePage}>Definir quantidade:</Text>

                <View style={styles.contentAmount}>
                    <TextInput style={styles.textInputAmount} value={qtd} onChangeText={(e) => setQtd(e)} />
                    <Text style={styles.coin}>{token ? token.name_token : "GPX"}</Text>
                </View>

                <View style={styles.contentPriceSell}>
                    <Text style={styles.textInfoPriceSell}>Preço de venda:</Text>
                    <TextInput style={styles.textInputPriceSell} value={valueCoin} onChangeText={(e) => setValueCoin(e)} />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        Último preço: <Text style={styles.price}>000.000,00GPX</Text>
                    </Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        Preço de compra: <Text style={styles.price}>{token ? token.single_value : "000.000,00"}GPX</Text>
                    </Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        Preço de mercado: <Text style={styles.price}>000.000,00GPX</Text>
                    </Text>
                </View>
            </View>

            <View style={styles.contentCheckbox}>
                <Checkbox
                    status={checked ? 'checked' : 'indeterminate'}
                    onPress={() => {
                        setChecked(!checked);
                    }}
                />
                <Text>Vender a preço de mercado</Text>
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => navigation.navigate('ConfirmPassword', { qtd: qtd, valueCoin: valueCoin, market: checked, purchase: false })}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>CONTINUAR</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default SellExchange;